import { v4 as uuid } from "uuid";
import { toJSON, toSlug } from "../../utils";
import { NFTStandard } from "../nft";
import { ERC1155Metadata } from "./erc1155";
import { ERC721Metadata, } from "./erc721";
export class NFTMetadataTemplate {
    constructor(params) {
        this.id = params.id || uuid();
        this.name = toSlug(params.name);
        this.contractId = params.contractId || "";
        this.ipfsHash = params.ipfsHash || "";
        this.standard = params.standard;
        switch (this.standard) {
            case NFTStandard.ERC1155: {
                this.metadata = new ERC1155Metadata(params.metadata);
                break;
            }
            case NFTStandard.ERC721: {
                this.metadata = new ERC721Metadata(params.metadata);
                break;
            }
        }
        this.createdAt = Number(params.createdAt || new Date().valueOf());
        this.updatedAt = Number(params.updatedAt || new Date().valueOf());
    }
    get json() {
        return toJSON(this);
    }
    updateMultipleAttributes(attributes) {
        this.metadata.updateMultipleAttributes(attributes);
        return this.metadata;
    }
}
